import React, { useState, useEffect, useRef } from "react";
import { Modal, Button, Skeleton, Space } from "antd";
import { PrinterOutlined } from "@ant-design/icons";
import { gql, useLazyQuery } from "@apollo/client";
import { useReactToPrint } from "react-to-print";
import Invoice from "@general/userPayment/invoice";
import { useNavigate } from "react-router-dom";
function UserInvoicesTableDetails({ invoiceId }) {
  const [invoiceDetails, setInvoiceDetails] = useState({});

  const contentRef = useRef(null);
 const reactToPrintFn = useReactToPrint({
    contentRef,
    onBeforeGetContent: async () => {
      await document.fonts.ready;
      try {
        await document.fonts.load('18px IRANSansXFaNum');
      } catch (e) {
        console.warn('font load failed', e);
      }
    },
    pageStyle: `
    @font-face {
      font-family: "IRANSansXFaNum";
      src: url("${window.location.origin}/fonts/woff2/IRANSansXFaNum-Regular.woff2") format("woff2");
    }
    .contract-wrapper,
    .contract-wrapper * {
      font-family: "IRANSansXFaNum" !important;
    }
  `,
  });


  const GETINVOICEDATA = gql`
    query GetInvoce($id: ID!) {
      getInvoice(id: $id) {
        id
        amountRial
        description
        createdAt
        finalAmount
        discountAmount
        user {
          gender
          name
        }
        paidAt
        cancelAt
        invoiceType
      }
    }
  `;
  const [getInvoiceData, invoiceData] = useLazyQuery(GETINVOICEDATA, {
    onError(error) {
      console.log(error.message);
      Modal.error({
        title: "مشکلی پیش آمده!",
        content: "لطفا دوباره تلاش کنید!",
        bodyStyle: { direction: "rtl" },
        okText: "باشه",
      });
    },
    onCompleted({ getInvoice }) {
      setInvoiceDetails(getInvoice);
    },
  });
  useEffect(() => {
    if (invoiceId) {
      getInvoiceData({ variables: { id: invoiceId } });
    }
  }, [invoiceId, invoiceDetails]);
  const navigate = useNavigate();

  if (invoiceData.loading)
    return (
      <>
        <Skeleton active round />
        <br />
        <Skeleton active round />
      </>
    );
  return (
    <>
      <Space align="baseline">
        <Button
          type="primary"
          onClick={reactToPrintFn}
          icon={<PrinterOutlined />}
          disabled={invoiceDetails?.paidAt ? false : true}
        >
          چاپ فاکتور
        </Button>

        {!invoiceDetails?.paidAt && !invoiceDetails?.cancelAt && (
          <Button
            onClick={() => navigate(`/invoice/${invoiceId}`)}
          >
            پرداخت
          </Button>
        )}
      </Space>
      <Invoice details={invoiceDetails} ref={contentRef} />
    </>
  );
}

export default UserInvoicesTableDetails;
